import { processEvent } from '../core/processEvent'
import { type FastpassRemoveFromCartEvent, type FastpassAddToCartEvent, type FastpassPurchaseEvent, type FastpassBeginCheckoutEvent } from '../types/fastpass-ga4-events'

export const sendFastpassAddToCartEvent = (eventParams: FastpassAddToCartEvent['eventParams']) => {
  const event: FastpassAddToCartEvent = {
    eventName: 'add_to_cart',
    eventParams,
  }
  processEvent({
    event,
  })
}

export const sendFastpassRemoveFromCartEvent = (eventParams: FastpassRemoveFromCartEvent['eventParams']) => {
  const event: FastpassRemoveFromCartEvent = {
    eventName: 'remove_from_cart',
    eventParams,
  }
  processEvent({
    event,
  })
}

export const sendFastpassPurchaseEvent = (serviceType: 'merchant' | 'campaign', eventParams: FastpassPurchaseEvent['eventParams']) => {
  const event: FastpassPurchaseEvent = {
    eventName: 'purchase',
    eventParams,
  }
  processEvent({
    event,
  })
  if (serviceType === 'merchant') {
    processEvent({
      event: {
        ...event,
        eventName: 'merchant_purchase',
      },
    })
  }
  else if (serviceType === 'campaign') {
    processEvent({
      event: {
        ...event,
        eventName: 'campaign_purchase',
      },
    })
  }
}

export const sendFastpassBeginCheckoutEvent = (eventParams: FastpassBeginCheckoutEvent['eventParams']) => {
  const event: FastpassBeginCheckoutEvent = {
    eventName: 'begin_checkout',
    eventParams,
  }
  processEvent({
    event,
  })
}
